// Replace with your request types
export const GET_HOME_RESTAURANT_REQUEST = "GET_HOME_RESTAURANT_REQUEST";
export const GET_HOME_RESTAURANT_RECEIVE = "GET_HOME_RESTAURANT_RECEIVE";
export const CLEAR_HOME_RESTURANT = "CLEAR_HOME_RESTURANT";
export const UPDATE_HOME_LOCATION = "UPDATE_HOME_LOCATION";
export const SET_INITIAL_HOME_LOCATION = "SET_INITIAL_HOME_LOCATION";
export const IS_HOMEPAGE_LOADED = "IS_HOMEPAGE_LOADED";
export const IS_NO_ORDER_TYPE = "IS_NO_ORDER_TYPE";
